export const CONTENT = '/content';
export const EMBED = '/embed';
export const GETLINK = '/getlink';
export const TASKS = '/tasks';
export const HOME = '/';